module.exports = __webpack_public_path__ + "img/chat.77e50cfe.png";